import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e801fafc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e801fafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e801fafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e801fafc')) {
      api.createRecord('e801fafc', component.options)
    } else {
      api.reload('e801fafc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e801fafc&scoped=true&", function () {
      api.rerender('e801fafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8AcmlQw3fHX0p/JS/comp/PopupBox.vue"
export default component.exports